import { createContext, useEffect, useState } from 'react';
import './App.css';
import NavigationBarComponent from './components/GeneralComponents/NavigationBarComponent';
import { HashRouter, Routes } from 'react-router-dom';
import { getTheme } from './utils/themeFunctions';
import { appStyle } from './utils/styles/mainStyles';
import { ParallaxProvider } from 'react-scroll-parallax';
import UAParser from 'ua-parser-js';
import { AppRoutes } from './utils/constants';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import  VisitorPopUpComponent  from './components/VisitorPopUpComponent';
import { getVisitorAPICall } from './utils/visitor/apiCalls';

const fpPromise = FingerprintJS.load();

export const ThemeContext = createContext();
export const VisitorContext = createContext();
export const serverUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_LOCAL_SERVER : process.env.REACT_APP_SERVER;

const App = () => {
  const [theme,setTheme] = useState(getTheme());
  const [visitor,setVisitor] = useState({});
  const [isMobile,setIsMobile] = useState(false)
  const [open,setOpen] = useState(!localStorage.getItem("VISITOR_ID"))
  let device = new UAParser().getResult().device
  
  useEffect(() => {
    if (!localStorage.getItem("VISITOR_ID")) {
      fpPromise
      .then(res => res.get())
      .then(data => {
        localStorage.setItem("VISITOR_ID",data.visitorId)
        setVisitor({...visitor,id:data.visitorId})
        getVisitorAPICall(data.visitorId).then((alreadyExists) => {
          setOpen(!alreadyExists)
        })
      })
    }
    setIsMobile(device.type == 'mobile')
  },[])
  
  return (
    <div style = {appStyle(theme)}>
      <HashRouter>
      <ThemeContext.Provider value = {[theme,setTheme]}>
        <VisitorContext.Provider value = {[visitor,setVisitor]}>
      <ParallaxProvider>
      <NavigationBarComponent />
      <div style = {{marginTop: '70px'}}></div>
      <VisitorPopUpComponent open = {open} setOpen = {setOpen}/>
      <Routes>
        {AppRoutes()}
      </Routes>
      </ParallaxProvider>
      </VisitorContext.Provider>
      </ThemeContext.Provider>
      </HashRouter>
    </div>
  );
}

export default App;
